import { ReactNode } from "react";

import { AbsoluteCenterWrapper } from "@bridgesplit/ui";

export default function UnauthenticatedPage({ children }: { children: ReactNode }) {
    return <AbsoluteCenterWrapper>{children}</AbsoluteCenterWrapper>;
}
